
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_1ry53_13",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_1ry53_14",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_1ry53_15",
  "visible-content-group": "awsui_visible-content-group_tc96w_1ry53_15",
  "visible-content-title": "awsui_visible-content-title_tc96w_1ry53_20",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_1ry53_30",
  "visible-content-option": "awsui_visible-content-option_tc96w_1ry53_36",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_1ry53_49",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_1ry53_64",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_1ry53_68",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_1ry53_108",
  "content-display-group-header": "awsui_content-display-group-header_tc96w_1ry53_115",
  "content-display": "awsui_content-display_tc96w_1ry53_64",
  "content-display-text-filter": "awsui_content-display-text-filter_tc96w_1ry53_156",
  "content-display-no-match": "awsui_content-display-no-match_tc96w_1ry53_157",
  "content-display-title": "awsui_content-display-title_tc96w_1ry53_161",
  "content-display-description": "awsui_content-display-description_tc96w_1ry53_170",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_1ry53_178",
  "content-display-group-children": "awsui_content-display-group-children_tc96w_1ry53_185",
  "root": "awsui_root_tc96w_1ry53_189",
  "modal-root": "awsui_modal-root_tc96w_1ry53_190",
  "trigger-button": "awsui_trigger-button_tc96w_1ry53_191",
  "cancel-button": "awsui_cancel-button_tc96w_1ry53_192",
  "confirm-button": "awsui_confirm-button_tc96w_1ry53_193",
  "custom": "awsui_custom_tc96w_1ry53_194",
  "content-before": "awsui_content-before_tc96w_1ry53_195",
  "second-column-small": "awsui_second-column-small_tc96w_1ry53_199",
  "wrap-lines": "awsui_wrap-lines_tc96w_1ry53_203",
  "striped-rows": "awsui_striped-rows_tc96w_1ry53_204",
  "content-density": "awsui_content-density_tc96w_1ry53_205",
  "page-size": "awsui_page-size_tc96w_1ry53_206",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_1ry53_207",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_1ry53_208",
  "sticky-columns": "awsui_sticky-columns_tc96w_1ry53_209",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_1ry53_210",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_1ry53_211",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_1ry53_212",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_1ry53_213"
};
  